import { useState } from 'react';
import { DEFAULT_SETTINGS } from '../utils/settings';

export const useLogs = (settings) => {
  const [logs, setLogs] = useState([]);

  const addLog = (line) => {
    const limit = settings?.logging?.retention ?? DEFAULT_SETTINGS.logging.retention;
    const capped = Math.max(0, limit);
    setLogs((prev) => [line, ...prev].slice(0, capped));
  };

  return { logs, addLog, setLogs };
};